import {
  createRuler,
  getProjectVersion,
  moveUploadButtonForNewImage,
  post_data,
  showAditionalImagePreview,
} from "./functions";
import { projectDataFields } from "./form_fields_and_columns";
import { isUserAdmin, isUserEditor} from "../helpers/is_user_.js";

export async function getProjectData(id) {
  const form = new FormData();
  const version = getProjectVersion();
  form.append(
    "data",
    JSON.stringify({ function: "get_project_data", id, version })
  );
  const response = await post_data("./includes/ajax.inc.php", form);
  const projectData = response.project_data;
  const yarnData = response.yarn_data;
  const fabricData = response.fabric_data;
  const sequinsData = response.sequins_data;
  const canRemoveReadonlyFlag = response.can_remove_readonly_flag;
  if (canRemoveReadonlyFlag || (isUserAdmin() && response.project_data.status == "9")) addUnlockIcon();
  return [projectData, yarnData, fabricData, sequinsData, response.folder];
}

export function renderProject(projectData) {

  // Special check for L_R (show only one side if L-R or pair is off)
  if (projectData.L_R == 0 && projectData.pair == 0) {
    const noLRElement = document.getElementById("no-L-R");
    if (noLRElement) {
      noLRElement.checked = true;
    }
  }


  for (const field of Object.keys(projectDataFields)) {

    const inputField = document.getElementById(projectDataFields[field]);
    // prettier-ignore
    const inputFieldCopy = document.getElementById("copy-" + projectDataFields[field]);

    if (!inputField) continue;

    if (inputField.type === "checkbox") {
      inputField.checked = projectData[field] != "" ? true : false;
      if (inputFieldCopy) {
        inputFieldCopy.checked = projectData[field] != "" ? true : false;
      }
    } else {
      inputField.value = projectData[field];
      if (inputFieldCopy) {
        inputFieldCopy.value = projectData[field];
      }
    }
  }

  document.getElementById("project-name").textContent = projectData.name;
}


export function showFilePreviewAndFilesUploaded(mainImage, folder) {
  // display main image file
  const imagePreviewContainer = document.querySelector(
    ".image-preview-container"
  );
  imagePreviewContainer.style.display = "flex"; // Show the image element
  const imagePreview = document.querySelector(".image-preview");
  imagePreview.src = "./uploads/files/" + mainImage;
  const mainImageName = mainImage.split("/")[1];
  const folderName = mainImage.split("/")[0];
  document.querySelector(".copy-form-container").classList.add("visible");
  moveUploadButtonForNewImage();
  createRuler();
  const uploadContainer = document.querySelector(".upload-container-addition");
  if (uploadContainer) {
    uploadContainer.classList.remove("d-none");
  }

  // show other files from project
  if (!folder || Object.keys(folder).length === 0) return;
  const documents = document.querySelector(".editor-form__documents");
  let docFileId = 0;
  let additionalImageExists = false;
  for (const file of Object.values(folder)) {
    if (file === mainImageName) continue;
    if (file.indexOf("additional") !== -1) {
      additionalImageExists = true;
      showAditionalImagePreview(`./uploads/files/${folderName}/${file}`);
      continue;
    }
    documents.innerHTML +=
      "<li class='editor-form__document'><span> " +
      file +
      "</span> <i class='fas fa-trash form-editor__icon remove-file' data-remove='file' data-id='" +
      docFileId +
      "'> </i> </li>";
    docFileId++;
  }
}

export function addUnlockIcon() {
  const icon = `<li class="navigation-button-list__item navigation-button-list__item--editor">
                <img src="./uploads/images/icon_lock.png" alt="lock" id="unlock" class="navigation-button-list__image"> <span class="navigation-button-list__tooltip">Unlock</span>
            </li>`;
  const container = document.querySelector(".navigation-button-list");
  container.innerHTML += icon;
}

